import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import DeviceList from './views/DeviceList.vue';
import DeviceDetail from './views/DeviceDetail.vue';
import DeviceDetailInactive from './views/DeviceDetailInactive.vue';
import DeviceActivation from './views/DeviceActivation.vue';

import AliasList from './views/AliasList.vue';
import ApiInfo from './views/ApiInfo.vue';
import AliasDetail from './views/AliasDetail.vue';
import ClientCreate from './views/ClientCreate.vue';

import UserList from './views/UserList.vue';

import Home from './views/Home.vue';
import Auth from './views/Auth.vue'

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', component: Home, name: 'home', meta: { requiresAuth: true} },
    { path: '/auth', component: Auth },
    { path: '/api', component: ApiInfo, 'name': 'api_info', meta: { requiresAuth: true} },
    { path: '/device/list', component: DeviceList, 'name': 'device_list', meta: { requiresAuth: true} },
    { path: '/device/activate', component: DeviceActivation, 'name': 'device_activate', meta: { requiresAuth: true} },
    { path: '/device/:id', component: DeviceDetail, 'name': 'device_detail', meta: { requiresAuth: true} },
    { path: '/device/:id/:timestamp', component: DeviceDetailInactive, 'name': 'device_detail_inactive', meta: { requiresAuth: true} },
    
    { path: '/channel/list', component: AliasList, 'name': 'alias_list', meta: { requiresAuth: true} },
    { path: '/channel/:id', component: AliasDetail, 'name': 'alias_detail', meta: { requiresAuth: true} },

    { path: '/user/list', component: UserList, 'name': 'user_list', meta: { requiresAuth: true} },
    { path: '/client/create', component: ClientCreate, 'name': 'client_create', meta: { requiresAuth: true} },
  ]
});


router.beforeResolve((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then(data => {
      if (data && data.signInUserSession) {
        //user = data;
      }
      next()
    }).catch(() => {
      
      next({
        path: '/auth'
      });
    });
  }
  next()
})

export default router